<button type="button" class="qo-trigger" [class.open]="open" [attr.aria-expanded]="open"
  aria-controls="quick-order-panel" (click)="toggle()">
  Quick Order
  <svg class="qo-caret" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="m6 9 6 6 6-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</button>

<div class="qo-panel" id="quick-order-panel" *ngIf="open" role="dialog" aria-label="Quick Order">

  <!-- Adding to cart needs an account. -->
  <div class="qo-signin" *ngIf="!signedIn">
    <p class="qo-title">Quick Order</p>
    <p class="qo-muted">Sign in to add items to your cart by part number.</p>
    <a class="qo-submit" routerLink="/login" (click)="close()">Log In</a>
  </div>

  <ng-container *ngIf="signedIn">
    <p class="qo-hint">Enter part numbers, or paste a list (one “SKU qty” per line).</p>

    <div class="qo-cols" aria-hidden="true">
      <span class="qo-col-part">Part #</span>
      <span class="qo-col-qty">Quantity</span>
    </div>

    <ol class="qo-rows" (scroll)="positionSuggestions()">
      <li *ngFor="let row of rows; let i = index" [class.has-error]="row.error">
        <div class="qo-row">
          <span class="qo-num">{{ i + 1 }}.</span>

          <div class="qo-part">
            <input #partInput type="text" autocomplete="off" spellcheck="false" [attr.aria-label]="'Part number, row ' + (i + 1)"
              [class.matched]="row.product" [(ngModel)]="row.text" (input)="onPartInput(row, partInput)"
              (paste)="onPartPaste(row, $event)" (blur)="onPartBlur(row)"
              (focus)="onPartFocus(row, partInput)" />
            <ul class="qo-suggest" *ngIf="row.showSuggestions && row.suggestions.length && suggestPos"
              [style.top.px]="suggestPos.top" [style.left.px]="suggestPos.left" [style.width.px]="suggestPos.width">
              <li *ngFor="let product of row.suggestions" (mousedown)="$event.preventDefault()"
                (click)="chooseSuggestion(row, product)">
                {{ product.sku }} - {{ product.productName }}
              </li>
            </ul>
          </div>

          <div class="qo-stepper">
            <button type="button" aria-label="Decrease quantity" [disabled]="row.qty <= 1" (click)="stepQty(row, -1)">−</button>
            <input #qtyInput type="number" min="1" inputmode="numeric" [attr.aria-label]="'Quantity, row ' + (i + 1)"
              [value]="row.qty" (change)="setQty(row, qtyInput)" />
            <button type="button" aria-label="Increase quantity" (click)="stepQty(row, 1)">+</button>
          </div>

          <button type="button" class="qo-remove" [attr.aria-label]="'Remove row ' + (i + 1)" (click)="removeRow(row)">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </div>
        <p class="qo-row-name" *ngIf="row.product && !row.error">{{ row.product.productName }}</p>
        <p class="qo-row-error" *ngIf="row.error">{{ row.error }}</p>
      </li>
    </ol>

    <div class="qo-foot">
      <button type="button" class="qo-more" (click)="addRows()">Add more rows</button>

      <div class="qo-notice" *ngIf="notice" [class.ok]="notice.kind === 'ok'" role="status">
        {{ notice.text }}
        <a routerLink="/shopping-cart" (click)="close()" *ngIf="notice.kind === 'ok'">View cart</a>
      </div>

      <button type="button" class="qo-submit" [disabled]="adding || !filledRows.length" (click)="addToCart()">
        {{ adding ? 'Adding...' : 'Add to Cart' }}
        <svg *ngIf="!adding" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6" />
          <path d="m11 8.5 3.5 3.5-3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </ng-container>
</div>
